import demo from './modules/demo'

import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuth: true }

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页 必须 name:index
      {
        path: 'index',
        name: 'index',
        meta,
        component: () => import('@/pages/index')
      },
      {
        path: 'cmailbox', //主席信箱
        name: 'cmailbox',
        meta: {
          title: '主席信箱',
          requiresAuth: false
        },
        component: () => import('@/pages/cmailbox')
      },
      {
        path: 'tradeinfo', //工会信息
        name: 'tradeinfo',
        meta: {
          title: '工会信息',
          requiresAuth: false
        },
        component: () => import('@/pages/tradeinfo')
      },
      {
        path: 'tradeactivity', //工会信息
        name: 'tradeactivity',
        meta: {
          title: '工会活动',
          requiresAuth: false
        },
        component: () => import('@/pages/tradeactivity')
      },
      {
        path: 'unionbenefits', //工会福利
        name: 'unionbenefits',
        meta: {
          title: '工会福利',
          requiresAuth: false
        },
        component: () => import('@/pages/unionbenefits')
      },
      {
        path: 'unionsubsidy', //工会补助
        name: 'unionsubsidy',
        meta: {
          title: '工会补助',
          requiresAuth: false
        },
        component: () => import('@/pages/unionsubsidy')
      },
      {
        path: 'deputy', //身边的代表
        name: 'deputy',
        meta: {
          title: '身边的代表',
          requiresAuth: false
        },
        component: () => import('@/pages/deputy')
      },
      {
        path: 'myunion', //我的工会
        name: 'myunion',
        meta: {
          title: '我的工会',
          requiresAuth: false
        },
        component: () => import('@/pages/myunion')
      },
      {
        path: 'task', //我的任务
        name: 'task',
        meta: {
          title: '我的任务',
          requiresAuth: false
        },
        component: () => import('@/pages/task')
      },
      {
        path: 'list/:title',
        name: 'list',
        meta,
        component: () => import('@/pages/list')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next(vm => vm.$router.replace(from.fullPath))
          },
          render: h => h()
        }
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: {
          beforeRouteEnter (to, from, next) {
            next(vm => vm.$router.replace(JSON.parse(from.params.route)))
          },
          render: h => h()
        }
      },
      // webview
      {
        path: 'webView',
        name: 'webView',
        meta,
        component: () => import('@/pages/common/webView')
      },
      {
        path: 'jdpay', //京东付款
        name: 'jdpay',
        meta: {
          title: 'JdPay',
          requiresAuth: false
        },
        component: () => import('@/pages/jdpay')
      }
    ]
  },
  demo
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login')
  },
  {
    path: '/AutoLogin',
    name: 'AutoLogin',
    component: () => import('@/pages/AutoLogin')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('@/pages/error-page-404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
